<template>
  <modal :active="active" @close="handleCloseModal">
    <div v-if="actionType == 'createModal'" slot="title">Create New News</div>
    <div v-else slot="title">Update News</div>
    <div class="col-12">
      <div class="col-12" style="margin-top: 10px; display: flex">
        <label style="align-items: center; display: flex" class="col-2"
          >Update</label
        >
        <textarea
          class="col-10 form-control"
          type="text"
          required
          v-model="content"
        />
      </div>
      <div class="col-12" style="margin-top: 10px; display: flex">
        <label style="align-items: center; display: flex" class="col-2"
          >Date</label
        >
        <input class="form-control" type="date" id="date" v-model="date" />
      </div>
      <div class="col-12" style="margin-top: 10px; display: flex">
        <label style="align-items: center; display: flex" class="col-2"
          >Category</label
        >
        <select class="custom-select" v-model="category">
          <option
            v-for="category in categories"
            :key="category.name"
            :value="category.id"
          >
            {{ category.name }}
          </option>
        </select>
      </div>
      <div class="col-12" style="margin-top: 10px; display: flex">
        <label style="align-items: center; display: flex" class="col-2"
          >Tags</label
        >
        <input class="form-control" type="text" v-model="tags" />
      </div>
      <div class="col-12" style="margin-top: 10px; display: flex">
        <label style="align-items: center; display: flex" class="col-2"
          >Status</label
        >
        <select class="custom-select" v-model="status">
          <option
            v-for="status in statusList"
            :key="status.name"
            :value="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </div>
    </div>
    <div slot="footer">
      <button type="button" class="btn btn-info" @click="handleSave()">
        Save
      </button>
    </div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import NewsStorer from "../../../../storers/StoreNews";
import { mapState } from "vuex";
export default {
  data() {
    return {
      content: null,
      category: null,
      tags: null,
      date: null,
      status: null,
      categories: [
        { id: "agriculture", name: "Agriculture" },
        { id: "commodities", name: "Commodities" },
        { id: "crypto", name: "Crypto" },
        { id: "stocks_etfs", name: "Stocks & ETFs" },
      ],
      statusList: [
        { id: "draft", name: "Draft" },
        { id: "private", name: "Private" },
        { id: "published", name: "Published" },
      ],
    };
  },
  props: {
    active: Boolean,
    actionType: String,
    activeNews: Object,
  },
  components: { Spinner, Modal },
  created: function () {},
  computed: {
    ...mapState({}),
  },
  methods: {
    init() {
      this.content = null;
      this.category = null;
      this.tags = null;
      this.date = null;
    },
    fillForm() {
      this.content = this.activeNews.content;
      this.category = this.activeNews.category;
      this.tags = this.activeNews.tags;
      this.date = this.activeNews.date;
      this.status = this.activeNews.status;
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    handleSave() {
      var news = NewsStorer();
      if (this.actionType == "updateModal") {
        news.id = this.activeNews.id;
      }
      news.content = this.content;
      news.tags = this.tags;
      news.category = this.category;
      news.date = this.date;
      news.status = this.status;
      this.$emit("saveRequest", news);
    },
  },
  watch: {
    actionType() {
      this.init();
      if (this.actionType == "updateModal") {
        this.fillForm();
      }
    },
  },
};
</script> 
 <style>
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/newsModal.vue